import Dexie from "dexie";

const db = new Dexie("zwing");

db.version(1).stores({
  user: "id,mobile,first_name,last_name,password,v_id,store_id",
  session:
    "++id,vu_id,settlement_date,trans_from,opening_balance,opening_time,closing_balance,closing_time,online_session_id,sync",
  setting: "++id,user_id,settings",
  products:
    "++id,barcode,&sku,name,mrp,rsp,special_price,uom,weight_flag,category,multiple_price,multiple_batch,current_stock,images,tax_details",
  cart:
    "++id,store_id,v_id,user_id,weight_flag,barcode,item_name,sku,qty,subtotal,unit_mrp,unit_rsp,discount,md_discount,tax,total,status,vu_id,date,time,tax_data,uom,session_id,terminal_id,online_cart_id,multiple_price,manual_discount_basis,manual_discount_factor,[store_id+vu_id+v_id],[store_id+vu_id+v_id+user_id]",
  customer:
    "++id,&mobile,first_name,last_name,email,gender,dob,address,gst,session_id,terminal_id,sync,online_c_id",
  order:
    "++id,&order_id,cart_id,status,sync,bill_remark,terminal_id,session_id,online_order_id",
  payment: "++id,order_id,invoice_id,type,amount,online_order_id",
  invoice:
    "++id,store_id,v_id,user_id,weight_flag,barcode,item_name,sku,qty,subtotal,unit_mrp,unit_rsp,discount,md_discount,tax,total,vu_id,date,time,tax_data,uom,[store_id+vu_id+v_id+user_id],order_id,payment_id,invoice_no,order_seq,is_offline,session_id,cust_mobile,terminal_id,sync",
  logs: "++id,date,source,status,description",
  invoiceId:
    "++id,date,time,order_id,invoice_id,online_order_id,type,v_id,vu_id,store_id,[store_id+vu_id+v_id]",
});

db.version(2).stores({
  products:
    "++id,barcode,&sku,name,mrp,rsp,special_price,uom,weight_flag,category,multiple_price,batch,serial,current_stock,images,tax_details,is_batch,is_serial",
  cart:
    "++id,store_id,v_id,user_id,weight_flag,barcode,item_name,sku,qty,subtotal,unit_mrp,unit_rsp,discount,md_discount,tax,total,status,vu_id,date,time,tax_data,uom,session_id,terminal_id,online_cart_id,multiple_price,manual_discount_basis,manual_discount_factor,batch_id,serial_id,[store_id+vu_id+v_id],[store_id+vu_id+v_id+user_id]",
  invoice:
    "++id,store_id,v_id,user_id,weight_flag,barcode,item_name,sku,qty,subtotal,unit_mrp,unit_rsp,discount,md_discount,tax,total,vu_id,date,time,tax_data,uom,[store_id+vu_id+v_id+user_id],order_id,payment_id,invoice_no,order_seq,is_offline,session_id,cust_mobile,terminal_id,batch_id,serial_id,sync",
});

db.version(3).stores({
  stock:
    "++id,barcode,name,department,category,brand,unit_mrp,qty,v_id,stock_point_id,batch_no,serial_no,sku,[stock_point_id+v_id+barcode],[stock_point_id+v_id]",
});

db.version(4).stores({
  logs: "++id,date,source,status,description,response,terminal_details",
});

db.version(5).stores({
  gvList:
    "++id,created_at,gift_value,gv_code,gv_group_id,&gv_id,sale_value,store_id,voucher_sequence",
});

db.version(6).stores({
  gvList:
    "++id,gv_group_id,&gv_id,is_received_boolean,sale_value,gift_value,gv_code,voucher_sequence,value_type",
});

db.version(7).stores({
  searchedProducts:
    "++id,barcode,&sku,name,mrp,rsp,special_price,uom,weight_flag,category,multiple_price,batch,serial,current_stock,images,tax_details,is_batch,is_serial",
});

db.version(8).stores({
  jobs: "++id,type,&date,time,[type+date]",
});

db.version(9).stores({
  stock:
    "++id,barcode,name,department,category,brand,unit_mrp,qty,v_id,stock_point_id,batch_no,serial_no,sku,is_scan,timestamp,[stock_point_id+v_id+barcode],[stock_point_id+v_id]",
});

db.open().catch(function(e) {
  console.error("Open failed: " + e);
});

// window.addEventListener("unhandledrejection", (e) => {
// console.log(e);
// });

export default db;
